import type { FaireProductEntity } from "../../entity_types/product";

export const p_xch6k5scn3: FaireProductEntity = {
  token: "p_xch6k5scn3",
  type: "product",
  name: "Mushrooms on Chai Leather Shoes Moccs Baby and Toddler",
  brandToken: "b_ynyj2tklh3",
  brandName: "Starry Knight Design",
  imageUrl: "https://cdn.faire.com/fastly/11117fe4e0c8b676576c25c9ea5f01d99ca42d90c0b9cda3a555a86f8d176eb2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c2016ad188bfe23e2cbf6c6bf618189f8e4fda96a6d12e4bb392d49bb797eb5d.jpeg",
    "https://cdn.faire.com/fastly/4a388251b9002140cfcb4621ad0760d28a969cb1af475284611452048c8714f5.jpeg",
    "https://cdn.faire.com/fastly/16b2d58f0f42e35b39419b65e85775ac62264cc3b23e061e44c5385e7cd01694.jpeg",
    "https://cdn.faire.com/fastly/f544fcce783bc1381821e35ddcccc9dd509211f859845ad4237baa3b5b32135b.jpeg",
    "https://cdn.faire.com/fastly/ef1c32e8b220c6ede9876d8de96260a250e8d0df3cbd535efb2f21b913ab9951.jpeg",
    "https://cdn.faire.com/fastly/0b3bf2dd5492649b69d419650c6586d44f529019fa42b4b44203bd981b365bb6.jpeg",
    "https://cdn.faire.com/fastly/e2212ed297dd7e67af50faac22099db46ea088d6df26fd1655fa6a51b1e69762.jpeg",
    "https://cdn.faire.com/fastly/8ec2bd87bb4af63cdffed1f6f646370431bdd2b401e1ebbe9ddd4b9820a8f8aa.jpeg"
  ],
  priceDollars: 21,
  description: "Starry Knight Design shoes are handmade in Montana USA by a team of local women with high-quality 100% leather and suede. Since 2008, We have been designing and making soft soled leather shoes for your tiny babies up to kids. Our Shoes are great for ages newborn to 4years:\n\n-Soft and non restrictive for developing feet\n\n-Soft Elastic band around ankle \n\n-Help keep socks on newborns\n\n-great for babies crawling around\n\n-perfect for balance when they start standing and walking \n\n-suede bottoms help make non slip for floors\n\n-good for house/daycare shoes for toddlers! Or with our Add on soles even outdoor shoes Starry Knight Design Shoes\n\n-- 100% high quality leather and suede\n\n-- Handmade in Montana USA \n\n- Current Turnaround Time 1-2weeks\n\n-- Please measure child's foot before ordering to select the correct size. Add 3/8” to measurement to get correct sole length. Refer to size chart link for correct sizing info",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:11.977Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
